/**
 * Availability domain Arabic translations
 */

import type { AvailabilityTranslation } from './types'

export const availabilityTranslationAr: AvailabilityTranslation = {
  admin: {
    availability: {
      title: 'توفر المصنع',
      subtitle: 'تكوين متغيرات المنتج المتاحة في كل مصنع',
      totalFactories: 'المصانع',
      totalVariants: 'المتغيرات',
      available: 'متاح',
      unavailable: 'غير متاح',
      coverage: 'التغطية',
      coverageDesc: 'من إجمالي التركيبات',
      matrix: 'مصفوفة التوفر',
      factory: 'المصنع',
      variant: 'المتغير',
      noData: 'لا توجد مصانع أو متغيرات متاحة',
    },
  },
}
